import { getSeatByPosition } from '@vista-digital/ocapi-utilities';
import { isSeatAvailableAndNotSelected, isSeatSelected, isSeatUnavailable } from './seat-utils';
export var Direction;
(function (Direction) {
    Direction[Direction["Left"] = 0] = "Left";
    Direction[Direction["Right"] = 1] = "Right";
})(Direction || (Direction = {}));
export const getSeatsUntil = (data, position, direction, predicate) => {
    const seats = new Array();
    let offset = 1;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        const nextSeat = getRelativeSeatOnRow(data.seatLayout, position, direction, offset);
        if (nextSeat === undefined || (predicate && predicate(nextSeat))) {
            break;
        }
        seats.push(nextSeat);
        offset++;
    }
    return seats;
};
export const getSeatsUntilAisle = (data, position, direction) => {
    return getSeatsUntil(data, position, direction);
};
export const seatOneSpaceAwayIsAvailable = (data, selectedSeats, position, direction) => {
    const oneSeatOver = getRelativeSeatOnRow(data.seatLayout, position, direction, 1);
    return !!(oneSeatOver && isSeatAvailableAndNotSelected(data, selectedSeats, oneSeatOver));
};
export const seatTwoSpacesAwayIsSelected = (data, selectedSeats, position, direction) => {
    const seatTwoSpacesAway = getSeatTwoSpacesAway(data, position, direction);
    return !!(seatTwoSpacesAway && isSeatSelected(selectedSeats, seatTwoSpacesAway));
};
export const seatTwoSpacesAwayIsUnavailable = (data, position, direction) => {
    const seatTwoSpacesAway = getSeatTwoSpacesAway(data, position, direction);
    return !!(seatTwoSpacesAway && isSeatUnavailable(data, seatTwoSpacesAway));
};
export const anySeatsUntilAisleAreSelected = (data, selectedSeats, position, direction) => {
    const seatsUntilAisle = getSeatsUntilAisle(data, position, direction);
    return seatsUntilAisle.some(s => isSeatSelected(selectedSeats, s));
};
export const getSeatTwoSpacesAway = (data, position, direction) => {
    return getRelativeSeatOnRow(data.seatLayout, position, direction, 2);
};
export const contiguousSeatBlockHasSingleAvailableSeat = (data, selectedSeats, position) => {
    const seatsInContiguousBlock = [
        ...getSeatsUntilAisle(data, position, Direction.Left),
        ...getSeatsUntilAisle(data, position, Direction.Right)
    ];
    return getAvailableSeatCount(data, selectedSeats, seatsInContiguousBlock) === 1;
};
export const contiguousSeatSubBlockHasSingleAvailableSeat = (data, selectedSeats, position) => {
    const seatsInContiguousSubBlock = [
        ...getSeatsUntil(data, position, Direction.Left, s => isSeatUnavailable(data, s)),
        ...getSeatsUntil(data, position, Direction.Right, s => isSeatUnavailable(data, s))
    ];
    return getAvailableSeatCount(data, selectedSeats, seatsInContiguousSubBlock) === 1;
};
const getAvailableSeatCount = (data, selectedSeats, seats) => {
    return seats.filter(s => isSeatAvailableAndNotSelected(data, selectedSeats, s)).length;
};
const getRelativeSeatOnRow = (seatLayout, position, direction, offset) => {
    // Since the map is inverted - positive increments are left, negative - right
    const directionAdjustment = direction === Direction.Left ? 1 : -1;
    const relativePosition = Object.assign(Object.assign({}, position), { columnNumber: position.columnNumber + offset * directionAdjustment });
    return getSeatByPosition(seatLayout, relativePosition);
};
//# sourceMappingURL=seat-gap-utils.js.map